import { useState } from 'react';

export const useSearchModels = (allOptionsList: string[]) => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchSuggestions = async (input: string) => {
    if (!input) {
      // If there is no searchTerm return an empty array
      setSuggestions([]);
      return;
    }
    if (!allOptionsList.length) {
      setSuggestions([]);
      return;
    }

    const filteredInput = input.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    const searchedSuggestion = allOptionsList.filter((option) => option.includes(filteredInput));

    if (!searchedSuggestion.length && allOptionsList.includes(filteredInput)) {
      setError(
        'Model not part of your selected body styles. Uncheck body styles or choose another model.',
      );
      setSuggestions([]);
      return;
    }

    // Wrong Input - No models name avaialble for this input
    if (!searchedSuggestion.length) {
      setError(
        "Input provided is not valid. Please enter the correct model name for the vehicle you're searching for.",
      );
      setSuggestions([]);
      return;
    }

    setSuggestions(searchedSuggestion);
  };

  return { suggestions, fetchSuggestions, error, setError };
};
